const WalterSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 -1 363 214"
    display="block"
  >
    <defs>
      <path
        id="a"
        d="m35.33.144.004.617-.01-.057.006-.56V.057L24.419 11.576l6.594 6.793L.055 127.887l33.734 35.668h.868l35.311-35.67L39.341 18.574l5.267-6.597L35.332.036z"
      />
      <path id="c" d="M0 .024h90.109v77.375H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        stroke="#212121"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth=".6"
        d="M184.882 1.992s4.656.218 6.553 2.556"
      />
      <path
        fill="#212121"
        d="M165.765 16.19s1.287-6.516 3.115-8.422c1.828-1.906 2.952-.917 2.952-.917s2.104-2.705 5.913-4.41c3.81-1.706 9.515-.967 11.863 1.05 2.348 2.017 2.386 2.941 2.386 2.941s1.512.236 2.343 1.401c.832 1.166 2.566 8.358 2.566 8.358"
      />
      <path
        fill="#F58449"
        d="m194.434 53.076-12.959 1.648-.254.036-.255-.036-12.96-1.648 2.57-10.054.005-.027 2.451-12.458h16.377l.747 3.802z"
      />
      <path
        fill="#F58449"
        d="M187.254 34.34c-5.308 6.809-12.126 8.448-16.678 8.682l.005-.027 2.451-12.458h13.475l.747 3.802Z"
      />
      <path
        fill="#F0642F"
        d="M171.832 20.86a5.266 5.266 0 1 1-10.531 0 5.266 5.266 0 0 1 10.531 0M201.332 20.902a5.266 5.266 0 1 1-10.531 0 5.266 5.266 0 0 1 10.531 0"
      />
      <path
        fill="#F58449"
        d="M196.428 26.6c-2.656 8.465-9.115 11.327-15.115 11.327s-12.46-2.862-15.116-11.328c-2.655-8.465 1.062-13.247 4.1-16.15a15.971 15.971 0 0 1 3.746-2.665c2.18-1.12 3.841-.919 7.27-.919 3.428 0 5.09-.201 7.27.919a15.972 15.972 0 0 1 3.745 2.664c3.039 2.904 6.756 7.686 4.1 16.151"
      />
      <path
        fill="#000"
        d="M185.412 25.083c-.196.167-.42.324-.67.464-.759.423-1.778.706-3.13.706-2.347 0-3.77-.846-4.567-1.81a4.014 4.014 0 0 1-.524-.808c-.437-.9-.611-1.593.375-2.12.987-.528 2.471 1.031 4.408 1.031h.26c1.938 0 3.61-1.693 4.65-1.009 1.04.685.673 2.299-.802 3.546"
      />
      <path
        fill="#ED1381"
        d="M184.741 25.547c-.758.423-1.777.706-3.128.706-2.348 0-3.77-.845-4.568-1.81 1.354-.567 3.259-.939 5.457-.152a7.784 7.784 0 0 1 2.24 1.256"
      />
      <path
        fill="#F0642F"
        d="m181.137 17.067-2.127 1.912a.263.263 0 0 0 .176.459h4.253a.263.263 0 0 0 .176-.459l-2.126-1.912a.263.263 0 0 0-.352 0"
      />
      <path
        fill="#EEE"
        d="M174.24 16.64c-2.993 0-5.036-2.343-4.632-4.814a.921.921 0 0 1 .012-.064c.374-2.069 2.408-3.528 4.62-3.528.56 0 1.108.093 1.622.267 1.534.518 2.753 1.75 3.01 3.325.404 2.471-1.64 4.813-4.631 4.813"
      />
      <path
        stroke="#EEE"
        strokeWidth=".901"
        d="M174.24 16.64c-2.993 0-5.036-2.343-4.632-4.814a.921.921 0 0 1 .012-.064c.374-2.069 2.408-3.528 4.62-3.528.56 0 1.108.093 1.622.267 1.534.518 2.753 1.75 3.01 3.325.404 2.471-1.64 4.813-4.631 4.813Z"
      />
      <path
        fill="#97DDCF"
        d="m175.862 8.501-6.242 3.26c.374-2.068 2.408-3.527 4.62-3.527.56 0 1.108.093 1.622.267"
      />
      <path
        fill="#212121"
        d="M190.677 6.47c0 .736-4.134 1.332-9.232 1.332-5.099 0-9.232-.596-9.232-1.332 0-.736 4.133-1.333 9.232-1.333 5.098 0 9.232.597 9.232 1.333"
      />
      <path
        fill="#EEE"
        d="M192.347 11.827c.403 2.47-1.64 4.812-4.633 4.812-2.992 0-5.036-2.342-4.632-4.812.343-2.103 2.398-3.593 4.632-3.593 2.234 0 4.289 1.49 4.633 3.593"
      />
      <path
        stroke="#EEE"
        strokeWidth=".901"
        d="M192.347 11.827c.403 2.47-1.64 4.812-4.633 4.812-2.992 0-5.036-2.342-4.632-4.812.343-2.103 2.398-3.593 4.632-3.593 2.234 0 4.289 1.49 4.633 3.593Z"
      />
      <path
        fill="#97DDCF"
        d="m189.343 8.501-6.242 3.26c.374-2.068 2.408-3.527 4.621-3.527.56 0 1.108.093 1.621.267"
      />
      <path
        stroke="#E60278"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth=".901"
        d="M179.593 11.175s.306-.88 1.38-.88c1.073 0 1.38.88 1.38.88"
      />
      <path
        fill="#000"
        d="M175.175 15.255a.935.935 0 1 1-1.87 0 .935.935 0 0 1 1.87 0M188.65 15.255a.935.935 0 1 1-1.871 0 .935.935 0 0 1 1.87 0"
      />
      <path
        stroke="#E60278"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth=".901"
        d="m169.027 11.175-2.754 4.13"
      />
      <path fill="#EEE" d="m192.868 11.175 3.567 4.08" />
      <path
        stroke="#E60278"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth=".901"
        d="m192.868 11.175 3.567 4.08"
      />
      <path
        fill="#EEE"
        d="M207.046 131.739s91.7 17.205 118.68 3.654v-24.778c-14.019-8.697-27.692-17.58-45.364-27.93-23.334-13.665-46.363-26.42-66.233-26.42l-7.083 75.474ZM155.502 131.739s-91.7 17.205-118.68 3.654v-24.778c14.019-8.697 27.692-17.58 45.364-27.93 23.334-13.665 46.363-26.42 66.233-26.42l7.083 75.474Z"
      />
      <path
        fill="#EEE"
        d="M262.633 104.935c0 20.939-13.222 38.79-31.772 45.659h-33.796a48.657 48.657 0 0 1-15.318-9.174 48.673 48.673 0 0 1-15.32 9.174h-33.795c-18.552-6.868-31.774-24.719-31.774-45.659 0-4.263.548-8.397 1.58-12.338v-.001c5.46-20.905 24.476-36.331 47.093-36.331 9.125 0 17.664 2.511 24.963 6.88a48.795 48.795 0 0 1 7.253 5.308 48.334 48.334 0 0 1 4.986-3.862l.001-.001a48.425 48.425 0 0 1 27.227-8.325c19.255 0 35.897 11.18 43.79 27.403a48.489 48.489 0 0 1 4.882 21.267"
      />
      <path
        fill="#EEE"
        d="m271.2 150.67-179.767-.076 11.004-57.997v-.001l70.827-4.071 15.795-.908 68.692-3.949.888 1.929z"
      />
      <path
        fill="#EEE"
        d="M282.837 213.257H80.027l12.137-66.514 178.291-.083zM194.651 64.856l-6.469-8.591H174.24l-7.378 11.178 1.231 6.836 25.433-3.911"
      />
      <path
        fill="#0D3880"
        d="m179.889 213.257-33.734-35.668 30.958-109.518-6.594-6.793 10.911-11.519v.087l-.006.56.01.057-.004-.617.002-.108 9.276 11.941-5.267 6.597 30.627 109.311-35.311 35.67z"
      />
      <g transform="translate(146.1 49.702)">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <path
          fill="#5C2261"
          d="M-33.088 100.905h27.299v-6.73h-27.299zM-5.789 94.175H21.51v-6.73H-5.789zM-33.088 87.445h27.299v-6.729h-27.299zM-5.789 80.715H21.51v-6.729H-5.789zM-33.088 73.986h27.299v-6.73h-27.299zM-5.789 67.256H21.51v-6.73H-5.789zM-33.088 60.526h27.299v-6.73h-27.299zM-5.789 53.796H21.51v-6.729H-5.789zM-33.088 47.066h27.299v-6.729h-27.299zM-5.789 40.337H21.51v-6.73H-5.789zM-33.088 33.607h27.299v-6.73h-27.299zM-5.789 26.877H21.51v-6.73H-5.789zM21.51 100.905h27.299v-6.73H21.51zM48.809 94.175h27.299v-6.73H48.809zM21.51 87.445h27.299v-6.729H21.51zM48.809 80.715h27.299v-6.729H48.809zM21.51 73.986h27.299v-6.73H21.51zM48.809 67.256h27.299v-6.73H48.809zM21.51 60.526h27.299v-6.73H21.51zM48.809 53.796h27.299v-6.729H48.809zM21.51 47.066h27.299v-6.729H21.51zM48.809 40.337h27.299v-6.73H48.809zM21.51 33.607h27.299v-6.73H21.51zM48.809 26.877h27.299v-6.73H48.809zM-33.088 19.755h27.299v-6.73h-27.299zM-5.789 13.025H21.51V6.296H-5.789zM-33.088 6.296h27.299v-6.73h-27.299zM-5.789-.434H21.51v-6.73H-5.789zM-33.088-7.164h27.299v-6.73h-27.299zM-5.789-13.894H21.51v-6.729H-5.789zM-33.088-20.624h27.299v-6.729h-27.299zM-5.789-27.353H21.51v-6.73H-5.789zM-33.088-34.083h27.299v-6.73h-27.299zM-5.789-40.813H21.51v-6.73H-5.789zM-33.088-47.543h27.299v-6.729h-27.299zM21.51 19.755h27.299v-6.73H21.51zM48.809 13.025h27.299V6.296H48.809zM21.51 6.296h27.299v-6.73H21.51zM48.809-.434h27.299v-6.73H48.809zM21.51-7.164h27.299v-6.73H21.51zM48.809-13.894h27.299v-6.729H48.809zM21.51-20.624h27.299v-6.729H21.51zM48.809-27.353h27.299v-6.73H48.809zM21.51-34.083h27.299v-6.73H21.51zM48.809-40.813h27.299v-6.73H48.809zM21.51-47.543h27.299v-6.729H21.51zM-33.088 168.266h27.299v-6.73h-27.299zM-5.789 161.536H21.51v-6.73H-5.789zM-33.088 154.806h27.299v-6.73h-27.299zM-5.789 148.076H21.51v-6.729H-5.789zM-33.088 141.347h27.299v-6.73h-27.299zM-5.789 134.617H21.51v-6.73H-5.789zM-33.088 127.887h27.299v-6.73h-27.299zM-5.789 121.157H21.51v-6.729H-5.789zM-33.088 114.428h27.299v-6.73h-27.299zM-5.789 107.698H21.51v-6.73H-5.789zM21.51 168.266h27.299v-6.73H21.51zM48.809 161.536h27.299v-6.73H48.809zM21.51 154.806h27.299v-6.73H21.51zM48.809 148.076h27.299v-6.729H48.809zM21.51 141.347h27.299v-6.73H21.51zM48.809 134.617h27.299v-6.73H48.809zM21.51 127.887h27.299v-6.73H21.51zM48.809 121.157h27.299v-6.729H48.809zM21.51 114.428h27.299v-6.73H21.51zM48.809 107.698h27.299v-6.73H48.809z"
          mask="url(#b)"
        />
      </g>
      <g>
        <path
          fill="#D6D6D6"
          d="M180.997 49.197h.015c5.58.003 10.065 1.275 12.882 2.362 1.138.439 2.004.848 2.559 1.13.453.232.789.642.929 1.13l1.419 4.947-2.05 9.938c-.447 1.896-2.978 2.277-3.962.597l-2.657-4.536-3.765-6.425-2.327-3.972-2.905-4.959a.157.157 0 0 0-.264-.012"
        />
        <path
          fill="#D6D6D6"
          d="M181.996 49.397a.157.157 0 0 0-.264.012l-2.905 4.959-2.327 3.972-3.765 6.425-2.657 4.536c-.984 1.68-3.515 1.299-3.961-.597l-2.05-9.938 1.418-4.946c.14-.49.476-.9.93-1.13.554-.283 1.42-.692 2.559-1.131 2.816-1.087 7.301-2.359 12.881-2.362h.015M276.96 150.019l50.158 15.898c15.623 6.663 33.263-3.557 35.253-20.424a25.449 25.449 0 0 0-15.807-26.602S287.287 93.479 272.44 90.6l4.52 59.418Z"
        />
        <path
          fill="#D6D6D6"
          d="m325.726 150.4-.304 13.122-48.463-13.503-4.52-59.418c14.928 2.893 41.349 14.18 53.285 20.014l.002 39.785Z"
        />
        <g transform="translate(0 90.577)">
          <mask id="d" fill="#fff">
            <use xlinkHref="#c" />
          </mask>
          <path
            fill="#D6D6D6"
            d="M85.589 59.442 35.429 75.34C19.807 82.003 2.167 71.783.176 54.916a25.449 25.449 0 0 1 15.807-26.602S75.26 2.902 90.11.024l-4.52 59.418Z"
            mask="url(#d)"
          />
        </g>
        <path
          fill="#212121"
          d="M78.362 138.055c.46 2.752 1.122 5.141 1.964 7.046 1.277 2.896 2.965 4.676 4.966 4.92 2.437.301 4.957-1.724 7.213-5.37.28-.452.555-.93.826-1.43 2.819-5.207 5.13-12.977 6.185-21.805 1.712-14.328-.443-26.741-4.88-30.255l-.051-.04c-.666-.516-1.383-.831-2.143-.924-.788-.098-1.586.05-2.381.417l-.005.001a7.29 7.29 0 0 0-1.592 1.029c-4.54 3.766-8.713 14.347-10.246 27.16-.86 7.195-.744 13.907.144 19.25"
        />
        <path
          fill="#E60278"
          d="M74.4 106.715c-.077 2.131-1.468 3.986-3.107 4.143-1.638.156-2.904-1.445-2.827-3.576.077-2.132 1.468-3.986 3.107-4.143 1.638-.156 2.904 1.445 2.827 3.576M288.148 106.715c.077 2.131 1.468 3.986 3.107 4.143 1.638.156 2.904-1.445 2.827-3.576-.077-2.132-1.468-3.986-3.107-4.143-1.638-.156-2.904 1.445-2.827 3.576"
        />
        <path
          fill="#D6D6D6"
          d="m175.723 110.439-30.428-2.707 31.257 11.722M176.789 111.285l6.297-7.856 6.297 7.46"
        />
        <path
          fill="#FFF"
          d="m183.409 118.282-2.37-26.353-10.739 2.826 6.051 2.882-2.301 26.075 22.96-2.435-3.767-5.322-8.297 2.812 34.184-11.536-38.245 3.359"
        />
        <path
          fill="#F0642F"
          d="M126.73 151.213c.29 0 .29-.45 0-.45s-.29.45 0 .45"
        />
        <path
          stroke="#212121"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth=".6"
          d="M173.842 5.447s1.149-2.728 5.834-4.354"
        />
        <path
          fill="#EEE"
          d="M140.045 102.65a7.967 7.967 0 1 0-15.934 0 7.967 7.967 0 0 0 15.934 0"
        />
        <path
          fill="#212121"
          d="M284.186 138.055c-.401 2.403-.957 4.53-1.652 6.298-.1.257-.205.507-.311.749-1.278 2.895-2.967 4.675-4.967 4.92-2.437.3-4.957-1.725-7.213-5.371-.28-.452-.555-.93-.826-1.429a39.644 39.644 0 0 1-1.966-4.26c-1.908-4.812-3.422-10.877-4.22-17.545-1.712-14.328.444-26.742 4.881-30.256l.051-.04c.666-.516 1.382-.831 2.143-.925a4.097 4.097 0 0 1 1.713.162c.183.055.366.123.549.202a3.905 3.905 0 0 1 .12.053l.003.003c.064.029.128.06.192.092.47.238.937.55 1.4.936 4.541 3.766 8.714 14.347 10.247 27.16.859 7.194.744 13.908-.144 19.25"
        />
        <path
          fill="#C44620"
          d="M255.815 84.81s-12.077-14.675-31.525-6.792l17.188 8.93 14.337-2.138Z"
        />
        <path
          fill="#F0642F"
          d="M253.16 84.076s-27.808-18.222-39.326 3.429l47.988 1.361-8.662-4.79Z"
        />
        <path
          fill="#F0642F"
          d="M229.258 98.916c3.382 1.687 6.618 2.555 5.713 5.697-1.373 4.76-5.066 6.22-8.884 4.773-3.819-1.448-5.582-3.16-10.854-1.18-5.274 1.98-3.96 6.409-2.66 9.525 2.43 5.897 7.64 8.291 13.127 10.011 5.487 1.72 8.105 2.791 13.955 4.058 5.852 1.266 26.33 6.15 26.33 6.15l-14.22-31.455-27.324-25.759s-3.628.69-6.737 2.92c-5.158 3.699-8.239 11.08-8.054 15.644.183 4.563 1.718 8.93 6.398 8.507 4.68-.423 4.557-2.448 6.497-7.344 1.94-4.896 3.332-3.234 6.713-1.547"
        />
        <path
          fill="#F58449"
          d="M224.44 80.736s12.821-3.984 47.379 9.621c0 0 5.588.74 9.696 14.903 0 0 7.573 23.547-.084 41.4 0 0-16.484-9.006-27.864-11.651-11.38-2.645-6.697-22.603-6.697-22.603l-9.057-17.722-13.372-13.948Z"
        />
        <path
          fill="#F0642F"
          d="M234.97 104.613c-1.372 4.76-5.065 6.22-8.883 4.773-3.819-1.448-5.582-3.16-10.854-1.18-5.274 1.98-3.96 6.409-2.66 9.525 2.43 5.897 7.64 8.291 13.127 10.011 5.487 1.72 8.105 2.791 13.955 4.058 5.852 1.266 26.33 6.15 26.33 6.15l-28.172-31.69"
        />
        <path
          fill="#F58449"
          d="M230.739 89.84c7.516 7.553 10.35 7.191 11.644 16.984 1.293 9.792 4.915 16.308 9.19 21.986 4.274 5.678 15.597 11.386 15.597 11.386.907.399 15.037 5.434 15.037 5.434.832-1.886 1.566-4.28 2.01-7 .86-5.28.975-13.514.077-20.615-1.6-12.644-5.637-21.394-10.197-25.09a28.443 28.443 0 0 0-1.597-1.007l-.005-.001c-.71-.415-3.348-.98-8.495-3.25"
        />
        <path
          fill="#F58449"
          d="M240.247 99.364s-7.67-12.23-15.957-3.31l-4.71 10.662-3.512-5.797 3.062-8.99 3.626-1.328 1.534-6.517 3.39-1.668 12.372 5.833.195 11.115Z"
        />
        <path
          fill="#F58449"
          d="m225.164 91.363 11.542 4.447 12.706 10.27 2.353.415-27.324-25.759s-3.628.69-6.737 2.92c-5.158 3.699-8.239 11.08-8.054 15.644.183 4.563 1.718 8.93 6.398 8.507 4.68-.423 4.557-2.448 6.497-7.344 1.94-4.896 3.332-3.234 6.713-1.547"
        />
        <path
          fill="#EEE"
          d="M221.894 102.65a7.967 7.967 0 1 1 15.934 0 7.967 7.967 0 0 1-15.934 0"
        />
        <path
          fill="#F58449"
          d="m228.157 88.504-3.716-.698.935 6.27 1.698 1.11c6.675-2.531 13.173 4.178 13.173 4.178l-1.55-3.31-2.097-4.125"
        />
        <path
          fill="#212121"
          d="M78.362 138.142c.4 2.403.957 4.53 1.652 6.298.1.257.205.507.311.749 1.278 2.895 2.966 4.675 4.967 4.92 2.436.3 4.957-1.725 7.213-5.371.28-.452.555-.93.826-1.429.69-1.273 1.348-2.7 1.966-4.26 1.908-4.812 3.422-10.877 4.22-17.545 1.711-14.328-.444-26.742-4.881-30.256l-.051-.04c-.666-.516-1.382-.83-2.143-.925a4.097 4.097 0 0 0-1.713.162 5.074 5.074 0 0 0-.549.202l-.004.002a3.905 3.905 0 0 0-.115.051c-.002 0-.003.003-.005.003a7.514 7.514 0 0 0-1.592 1.028c-4.54 3.766-8.713 14.347-10.246 27.16-.86 7.194-.744 13.908.144 19.25"
        />
        <path
          fill="#C44620"
          d="M106.733 84.897s12.077-14.675 31.525-6.792l-17.188 8.93-14.337-2.138Z"
        />
        <path
          fill="#F0642F"
          d="M109.388 84.163s27.808-18.222 39.326 3.429l-47.988 1.361 8.662-4.79Z"
        />
        <path
          fill="#F0642F"
          d="M133.29 99.003c-3.382 1.687-6.618 2.555-5.713 5.697 1.372 4.76 5.066 6.22 8.884 4.773 3.819-1.447 5.582-3.16 10.854-1.18 5.274 1.98 3.96 6.409 2.66 9.525-2.43 5.897-7.64 8.291-13.127 10.011-5.487 1.72-8.105 2.791-13.955 4.058-5.852 1.266-26.33 6.15-26.33 6.15l14.22-31.455 27.324-25.759s3.628.69 6.737 2.92c5.158 3.699 8.239 11.08 8.054 15.644-.183 4.563-1.718 8.93-6.398 8.507-4.68-.423-4.558-2.448-6.498-7.344-1.94-4.896-3.331-3.234-6.712-1.547"
        />
        <path
          fill="#F58449"
          d="M138.107 80.823s-12.82-3.984-47.378 9.622c0 0-5.588.74-9.696 14.902 0 0-7.574 23.547.084 41.4 0 0 16.484-9.006 27.864-11.651 11.38-2.645 6.696-22.603 6.696-22.603l9.058-17.722 13.372-13.948Z"
        />
        <path
          fill="#F0642F"
          d="M127.577 104.7c1.372 4.76 5.066 6.22 8.884 4.773 3.819-1.448 5.582-3.16 10.854-1.18 5.274 1.98 3.96 6.409 2.66 9.525-2.43 5.897-7.64 8.291-13.127 10.011-5.487 1.72-8.105 2.791-13.955 4.058-5.852 1.266-26.33 6.15-26.33 6.15l28.172-31.69"
        />
        <path
          fill="#F58449"
          d="M98.548 88.754c-5.148 2.27-7.785 2.835-8.495 3.25l-.005.001c-.519.303-1.053.64-1.597 1.007-4.56 3.696-8.597 12.446-10.197 25.09-.898 7.1-.783 15.334.077 20.616.444 2.72 1.178 5.113 2.01 6.999 0 0 14.13-5.035 15.037-5.434 0 0 11.323-5.708 15.597-11.386 4.275-5.678 7.897-12.194 9.19-21.986 1.294-9.793 4.128-9.43 11.644-16.983"
        />
        <path
          fill="#F58449"
          d="M122.301 99.451s7.67-12.23 15.957-3.31l4.71 10.662 3.512-5.797-3.062-8.99-3.626-1.328-1.534-6.517-3.39-1.668-12.373 5.833-.194 11.115Z"
        />
        <path
          fill="#F58449"
          d="m137.383 91.45-11.54 4.447-12.707 10.27-2.353.415 27.324-25.759s3.628.69 6.737 2.92c5.158 3.699 8.239 11.08 8.054 15.644-.183 4.563-1.718 8.93-6.398 8.507-4.68-.423-4.558-2.448-6.498-7.344-1.94-4.896-3.331-3.234-6.712-1.547"
        />
        <path
          fill="#EEE"
          d="M140.653 102.738a7.967 7.967 0 1 0-15.933 0 7.967 7.967 0 0 0 15.933 0"
        />
        <path
          fill="#F58449"
          d="m134.39 88.591 3.717-.698-.935 6.27-1.698 1.11c-6.675-2.531-13.173 4.178-13.173 4.178l1.55-3.309 2.097-4.126"
        />
      </g>
    </g>
  </svg>
);

export default WalterSvg;
